import { withRouter } from 'react-router'
import css from './footer.css'
import { START_IMAGE, GIF_MAKER } from '../../route'

const Footer = withRouter(({ match: { url }, history: { push }, checkLoginStatus, isLoggedIn }) => {
    const onClick = () => {
        if (isLoggedIn !== undefined && !isLoggedIn && checkLoginStatus) {
            checkLoginStatus()
            return
        }
        push(START_IMAGE)
    }
    return (
        <div className={css.footerLinks}>
            <div className={css.tosLinks}>
                <a href="/community-guidelines" target="_blank">
                    Community Guidelines
                </a>
                <a href="/privacy" target="_blank">
                    Privacy Policy
                </a>
            </div>
            {url === GIF_MAKER && (
                <div className={css.showStartImageButton} onClick={onClick}>
                    Choose your inspiration <span className={css.startImageArrow} />
                </div>
            )}
        </div>
    )
})

export default Footer
